export enum ScriptStatus {
  Error = 'error',
  Idle = 'idle',
  Loading = 'loading',
  Ready = 'ready'
}

export enum EventTypes {
  Error = 'error',
  Load = 'load'
}

export enum Attribute {
  DataStatus = 'data-status'
}
